import { render, staticRenderFns } from "./price-categories.vue?vue&type=template&id=c53b3228&scoped=true&"
import script from "./price-categories.ts?vue&type=script&lang=ts&"
export * from "./price-categories.ts?vue&type=script&lang=ts&"
import style0 from "./price-categories.scss?vue&type=style&index=0&id=c53b3228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53b3228",
  null
  
)

export default component.exports